




































































































































import { Component, Vue } from "vue-property-decorator";
import ajax from "@/lib/ajax";
import AddFlightRouteXML from "./modals/addFlightRouteXML.vue";

@Component({
  components: { AddFlightRouteXML },
})
export default class FlightRoutesXML extends Vue {
  breadcrumbsItems = [
    {
      text: "Ana Sayfa",
      disabled: false,
      to: "/main/home",
    },
    {
      text: "Tanımlamalar",
      disabled: true,
    },
    {
      text: "Uçuş Rotaları - XML",
      disabled: true,
    },
  ];

  serviceNames: string[] = [];
  selectedService: string | null = null;
  origin: string = "";
  destination: string = "";
  filteredRoutes: any[] = [];
  routesLoaded: boolean = false;
  isOpenModal: boolean = false;
  editItem: any = null;
  headers: any[] = [
    { text: "Origin", value: "origin" },
    { text: "Destination", value: "destination" },
    { text: "Servis İsmi", value: "serviceName" },
    { text: "URL", value: "url" },
    { text: "İşlemler", value: "actions", sortable: false },
  ];

  async mounted() {
    await this.loadServiceNames();
  }

  async loadServiceNames() {
    try {
      const response = await ajax.get(
        "/api/services/app/Admin/GetServiceNamesForXmlRoutes"
      );
      if (response.data.result) {
        this.serviceNames = response.data.result;
      }
    } catch (error) {
      console.error("Servis isimleri yüklenirken hata oluştu:", error);
    }
  }

  onServiceChange() {
    // Servis değiştiğinde otomatik arama yapılabilir veya kullanıcı butona basabilir
  }

  formatOrigin() {
    if (!this.origin) return;

    // Büyük harfe çevir ve sadece harfleri al, maksimum 3 karakter
    this.origin = this.origin.toUpperCase().replace(/[^A-Z]/g, '').substring(0, 3);
  }

  formatDestination() {
    if (!this.destination) return;

    // Büyük harfe çevir ve sadece harfleri al, maksimum 3 karakter
    this.destination = this.destination.toUpperCase().replace(/[^A-Z]/g, '').substring(0, 3);
  }

  async searchRoutes() {
    if (!this.selectedService && !this.origin && !this.destination) {
      this.$swal({
        icon: 'warning',
        title: 'Uyarı',
        text: 'Lütfen en az bir filtre seçin (Servis, Origin veya Destination)',
        confirmButtonText: 'Tamam',
      });
      return;
    }

    try {
      // API parametrelerini oluştur
      let params: any = {};

      if (this.selectedService) {
        params.ServiceName = this.selectedService;
      }

      if (this.origin) {
        params.Origin = this.origin;
      }

      if (this.destination) {
        params.Destination = this.destination;
      }

      // API çağrısı
      const response = await ajax.get('/api/services/app/Admin/GetFlightXmlRoutes', {
        params: params
      });

      if (response.data.success && response.data.result) {
        this.filteredRoutes = response.data.result.items || [];
        this.routesLoaded = true;
      }
    } catch (error) {
      console.error("Rotalar yüklenirken hata oluştu:", error);
      this.filteredRoutes = [];
      this.routesLoaded = false;
    }
  }

  openModal() {
    this.editItem = null;
    this.isOpenModal = true;
  }

  editRoute(item: any) {
    this.editItem = { ...item };
    this.isOpenModal = true;
  }

  closeModal() {
    this.isOpenModal = false;
    this.editItem = null;
    // Listeyi yenile
    this.searchRoutes();
  }

  cancelModal() {
    this.isOpenModal = false;
    this.editItem = null;
  }

  confirmDelete(item: any) {
    this.$swal({
      title: "Rota Silinecektir",
      text: "Silmek istediğinize emin misiniz?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Evet, Sil",
      cancelButtonText: "Hayır",
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteRoute(item);
      }
    });
  }

  async deleteRoute(item: any) {
    try {
      const response = await ajax.delete(
        `/api/services/app/Admin/DeleteFlightXmlRoute?id=${item.id}`
      );

      if (response.data.success) {
        Vue.$toast.success("Silme Başarılı");
        // Listeyi yenile
        this.searchRoutes();
      }
    } catch (error) {
      console.error("Rota silinirken hata oluştu:", error);
    }
  }
}
